import $ from 'jquery';
//import 'jquery';
import './bootstrap';
import smoothscroll from 'smoothscroll-polyfill';
import retina from 'retinajs';


import './map-settings';
import './infoModal';
import './ajaxPublications';
import './ajaxKnowledge';
import umeReadyAccordions from './accordion';
import accordionByLink from "./accordionByLink";
import umeMoreFrontend from './ume-more-frontend';
import umeMenuInit from './menu';
import umeSlidersInit from  './events-slider';
import scrollDownOnClick from './scrollDown';
import initSliders from "./slider";
import initUpcomingEventsSliders from "./upcoming-events";
import correctActive from "./one-pager-menu-marking";
//import lazyLoadIframes from "./lazyLoadIframes";
import showHiddenStaffContact from "./staffCard";
import tableResponsive from "./table";
import checkTitleSize from "./checkTitleSize";
import showScrollTop from "./scrollTop";
import generalSearch from "./generalSearch";
import switchLanguage from './polylangSwitcher';
import counter from './counterBlockAnimation';
import initCopyClipboard from "./clipboard-copy";
import loadCoverVideo from "./loadVideo";
import resetScrollAfterModalClose from "./resetScrollToPositionAfterModalCloses";
import floatingTeaser from "./floating-teaser";
import setScrollPadding from "./setScrollPadding";
import listHasLink from "./listHasLink";
import modal from "./modal";
import checkForMenuOverLength from "./checkForMenuOverLength";
import categoryControls from "./categoryPage";
import languageTabSwitcher from "./languageTabSwitcher";

import anchorMenu from "../../../ume-blocks/src/js/block-anchor-holder/js/frontend";
import consentmanager from "./consentmanager";
import consentmanagerHandleBackground from "./consentmanagerHandleBackground";
import './consentmanagerInstaFeed';
import videoModal from "./videoModal";
import umeTabs from "../../../ume-blocks/src/js/block-tab-holder/js/frontend";


$(document).ready(() => {
    umeMenuInit();
    loadCoverVideo();
    scrollDownOnClick();
    umeMoreFrontend();
    umeSlidersInit();
    umeReadyAccordions();
    smoothscroll.polyfill();
    retina();
    initSliders();
    initUpcomingEventsSliders();
    accordionByLink();
    correctActive();
    //lazyLoadIframes();
    showHiddenStaffContact();
    tableResponsive.init();
    checkTitleSize();
    showScrollTop();
    generalSearch();
    switchLanguage();
    counter.init();
    initCopyClipboard();
    resetScrollAfterModalClose();
    floatingTeaser();
    anchorMenu.init();
    listHasLink();
    checkForMenuOverLength();
    modal.init();
    categoryControls();
    languageTabSwitcher();
    videoModal();
    umeTabs();

    consentmanager();
    consentmanagerHandleBackground();
});
const loadEvent = new CustomEvent('customUmeLoadEvent', {});
window.onload = (event) => {
    document.dispatchEvent(loadEvent);
    setTimeout(() =>{
        setScrollPadding();
    }, 200)

};
let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if(currentWidth === window.innerWidth) return;
    umeMenuInit();
    loadCoverVideo();
    floatingTeaser();
    setScrollPadding();
    checkForMenuOverLength();
    videoModal();
    currentWidth = window.innerWidth;


});
window.addEventListener('orientationchange', () => {
    umeMenuInit();
    floatingTeaser();
    setScrollPadding();
    checkForMenuOverLength();
    videoModal();
});

document.addEventListener('customUmeEvent', () => {
    tableResponsive.init();
});


